var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"72","height":"72","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"72","height":"72","fill":_vm.bright ? '#F8F8F8' : '#F2F2F7',"storke":_vm.bright ? '#F8F8F8' : '#EEE'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }